import { gsap, CustomEase } from '../global/gsap';

const initOverlapPanels = (sections) => {
    sections.forEach((section) => {
        const panels = section.querySelectorAll('.js-overlap-panel');
        const button = section.querySelector('.js-back-to-top');

        gsap.set(panels, {
            scale: 0.85
        });

        panels.forEach((panel) => {
            const panelTl = gsap.timeline({
                scrollTrigger: {
                    trigger: panel,
                    scrub: 1.1,
                    start: 'top bottom',
                    end: 'top 25%',
                    invalidateOnRefresh: true
                },
            });

            panelTl.to(panel, {
                scale: 1,
                ease: CustomEase.create('custom', '0.22, 1, 0.36, 1')
            });
        });

        if (button) {
            const buttonTl = gsap.timeline({
                scrollTrigger: {
                    trigger: panels[panels.length - 1],
                    start: 'bottom 90%',
                    invalidateOnRefresh: true,
                    onEnter: () => {
                        button.classList.toggle('is-active');
                    },
                    onLeaveBack: () => {
                        button.classList.toggle('is-active');
                    },
                },
            });

            const target = button.getAttribute('href');
            const targetEl = document.querySelector(`${target}`);

            button.addEventListener('click', (event) => {
                // Prevents anchor tag jumping the scroll position
                event.preventDefault();

                gsap.to(window, {
                    duration: 0.5,
                    scrollTo: {
                        y: targetEl
                    }
                });
            });
        }
    });
};

export default initOverlapPanels;
